import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import {
  linkUserMatrix,
  sentEmailValidateCodeUser,
  unlinkUserMatrix,
} from './User.service';
import { UserType } from './User.types';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';

export function useSentEmailValidateCodeUser() {
  const queryChanel = useQueryChanel();

  return useMutation(sentEmailValidateCodeUser, {
    onSuccess(_, obj) {
      notification.success({
        message: 'Sucesso!',
        description: `E-mail enviado com o código de acesso para ${
          obj.userType === UserType.customer ? 'o cliente' : 'a seguradora'
        }!`,
      });

      queryChanel({
        refetchQueries: [
          obj.userType === UserType.customer
            ? ['customer/detail/general', obj.userId]
            : ['getInsurer', obj.userId],
        ],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useLinkUserMatrix() {
  const queryChanel = useQueryChanel();

  return useMutation(linkUserMatrix, {
    onSuccess(_, obj) {
      notification.success({
        message: 'Sucesso!',
        description: `Usuário ${
          obj.userType === UserType.customer ? 'do cliente' : 'da seguradora'
        } foi vinculado a matriz com sucesso!`,
      });

      queryChanel({
        refetchQueries: [
          obj.userType === UserType.customer
            ? ['customer/detail/general', obj.userId]
            : ['getInsurer', obj.userId],
        ],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useUnlinkUserMatrix() {
  const queryChanel = useQueryChanel();

  return useMutation(unlinkUserMatrix, {
    onSuccess(_, obj) {
      notification.success({
        message: 'Sucesso!',
        description: `Usuário ${
          obj.userType === UserType.customer ? 'do cliente' : 'da seguradora'
        } foi desvinculado com sucesso!`,
      });

      queryChanel({
        refetchQueries: [
          obj.userType === UserType.customer
            ? ['customer/detail/general', obj.userId]
            : ['getInsurer', obj.userId],
        ],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
